/**
 * Renders the icon for a transaction custom field by name.
 * Used in settings table and drag overlay.
 */
import { ReactElement } from "react";
import { SxProps, Theme } from "@mui/material";
import ReceiptIcon from "@mui/icons-material/Receipt";
import NoteIcon from "@mui/icons-material/Note";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import DescriptionIcon from "@mui/icons-material/Description";
import LabelIcon from "@mui/icons-material/Label";
import InventoryIcon from "@mui/icons-material/Inventory";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import NumbersIcon from "@mui/icons-material/Numbers";
import type { TransactionCustomFieldIconName } from "../../../types";

const NoIcon = () => null;

const ICON_MAP: Record<TransactionCustomFieldIconName, React.ComponentType<{ sx?: SxProps<Theme>; fontSize?: "small" | "medium" | "inherit" }>> = {
  no_icon: NoIcon,
  receipt: ReceiptIcon,
  note: NoteIcon,
  attach_file: AttachFileIcon,
  description: DescriptionIcon,
  tag: LabelIcon,
  invoice: InventoryIcon,
  picture_as_pdf: PictureAsPdfIcon,
  numbers: NumbersIcon,
};

const DEFAULT_ICON = DescriptionIcon;

interface TransactionFieldIconProps {
  icon?: TransactionCustomFieldIconName;
  fontSize?: "small" | "medium" | "inherit";
  sx?: SxProps<Theme>;
}

export function TransactionFieldIcon({ icon, fontSize = "small", sx }: TransactionFieldIconProps): ReactElement | null {
  if (icon === "no_icon") return null;
  const IconComponent = icon && ICON_MAP[icon] ? ICON_MAP[icon] : DEFAULT_ICON;
  return <IconComponent fontSize={fontSize} sx={{ color: "text.secondary", ...sx }} />;
}
